import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            主题索引
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按主题分类浏览内容，快速找到你感兴趣的爆料领域
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => {
            const accentStyles =
              item.color === 'primary'
                ? 'bg-primary-50 border-primary-200/70 hover:border-primary-300 group-hover:bg-primary-100/60'
                : item.color === 'accent'
                ? 'bg-accent-50 border-accent-200/70 hover:border-accent-300 group-hover:bg-accent-100/60'
                : 'bg-secondary-50 border-secondary-200/70 hover:border-secondary-300 group-hover:bg-secondary-100/60';

            const iconStyles =
              item.color === 'primary'
                ? 'bg-primary-500 text-white'
                : item.color === 'accent'
                ? 'bg-accent-500 text-white'
                : 'bg-secondary-500 text-white';

            const countStyles =
              item.color === 'primary'
                ? 'text-primary-700 bg-primary-100'
                : item.color === 'accent'
                ? 'text-accent-700 bg-accent-100'
                : 'text-secondary-700 bg-secondary-100';

            return (
              <div
                key={item.id}
                className={`group border rounded-xl p-5 transition-all duration-300 cursor-pointer ${accentStyles}`}
              >
                <div className="flex items-start gap-4">
                  <div className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl ${iconStyles} flex-shrink-0`}>
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading font-bold text-foreground-900 text-base md:text-lg">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                      {item.description}
                    </p>
                    <div className="mt-3 flex items-center justify-between">
                      <span className={`px-2 py-0.5 rounded-md text-xs font-semibold ${countStyles}`}>
                        {item.count.toLocaleString()} 篇
                      </span>
                      <span className="text-xs text-foreground-400 group-hover:text-primary-500 transition-colors">
                        进入 →
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}